<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <origen-deuda-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import OrigenDeudaCrud from "./OrigenDeudaCrud";
    export default {
        name: "OrigenDeuda",
        components: {OrigenDeudaCrud}
    }
</script>

<style scoped>

</style>

